import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import { EContactCustomId } from "@rentiohq/shared-frontend/dist/redux/contact/contact.types";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { IRootStore } from "redux/reducers";
import {
  resolveContactOrMeMaster,
  toContactId,
} from "./contactOrMeMaster.utils";

// TODO: Replace actual me-master ID with just me-master (doesn't work yet in new API)
export const useContactOrMeMaster = () => {
  const params = useParams<{ contactId: string }>();
  const { contactMeMaster } = authHooks.useSelf();

  const meMasterState = useSelector(
    (state: IRootStore) =>
      state.contact.contactsById[EContactCustomId.MeMaster],
  );

  return resolveContactOrMeMaster({
    routeContactId: toContactId(params.contactId),
    meMaster: {
      id: contactMeMaster?.id,
      isFetching: meMasterState?.isFetching,
      fetchError: meMasterState?.fetchError,
    },
  });
};
